<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        :hide-button="true"
        @onClick="abrirForm"
      />

      <div id="qrcode">
        <div class="mb-4">
          <label for="example-datepicker"
            >Digite o código do insumo e pressione ENTER</label
          >
          <b-form-tags
            v-model="qrcodes"
            input-id="tags-basic"
            placeholder="Digite o código do insumo..."
          ></b-form-tags>
        </div>

        <div class="mb-4">
          <b-form-group
            v-slot="{ ariaDescribedby }"
            label="Selecione o tamanho do QrCode"
          >
            <b-form-radio
              v-model="sizeSelected"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="150"
              >Pequeno</b-form-radio
            >
            <b-form-radio
              v-model="sizeSelected"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="250"
              >Médio</b-form-radio
            >
            <b-form-radio
              v-model="sizeSelected"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="400"
              >Grande</b-form-radio
            >
          </b-form-group>
        </div>

        <b-button variant="primary" @click="gerar">Gerar</b-button>

        <b-modal id="rel-qrcode" size="xl" title="Relatório de QrCode">
          <vue-html2pdf
            ref="html2Pdf"
            style="display: none"
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            :pdf-quality="2"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            :html-to-pdf-options="htmlToPdfOptions"
            :manual-pagination="false"
            @beforeDownload="beforeDownload($event)"
            @hasStartedGeneration="hasStartedGeneration"
            @hasGenerated="hasGenerated($event)"
          >
            <section slot="pdf-content">
              <div>
                <div v-for="item in items" :key="item._id">
                  <div class="w-50 ml-0 mr-0 mx-auto text-center">
                    <div class="row">
                      <div class="col-12">
                        <img :src="item.qrcode" :height="sizeSelected" />
                      </div>
                      <div class="col-12">
                        <b class="h4"
                          >{{ item.descricao }} <br />{{ item.obs }}</b
                        >
                      </div>
                    </div>
                  </div>
                  {{ marginBottom }}
                </div>
              </div>
            </section>
          </vue-html2pdf>

          <div>
            <div v-for="item in items" :key="item._id">
              <div class="w-50 ml-0 mr-0 mx-auto text-center">
                <div class="row">
                  <div class="col-12">
                    <img :src="item.qrcode" :height="sizeSelected" />
                  </div>
                  <div class="col-12">
                    <b class="h4">
                      {{ item.codigo }} -
                    </b>
                    <b v-show="item.descricao_pai !== undefined" class="h4">
                      {{ item.descricao_pai }} <br
                    /></b>
                    <b class="h4">
                      {{ item.descricao }} <br />{{ item.obs }} <br />
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template v-slot:modal-header>
            <div class="ml-auto">
              <b-button
                class="mr-2"
                variant="danger"
                @click="$bvModal.hide('rel-qrcode')"
                >Sair</b-button
              >
              <b-button variant="primary" @click="generateReport"
                >Imprimir</b-button
              >
            </div>
          </template>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import alertMixin from '@/src/mixins/alertMixin'
import insumoService from '../../../../services/serviceInsumoObra'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: { Layout, HeaderPage, VueHtml2pdf },
  mixins: [alertMixin],
  data() {
    return {
      isLoading: false,
      pageTitles: {
        title: 'Relatório de QrCode',
        subTitle: '',
        currentPage: 1,
        perPage: 20,
        items: [],

        qrcodes: [],
        marginBottom: 10,
      },
      sizeSelected: null,
      htmlToPdfOptions: {
        filename: `qrcode.pdf`,
        margin: [8, 10, 10, 10],
        image: {
          type: 'jpeg',
          quality: 1,
        },
        html2canvas: {
          scale: 2,
          logging: true,
          dpi: 192,
          letterRendering: true,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          compressPDF: true,
        },
      },
    }
  },
  watch: {
    sizeSelected(value) {
      const bottom = value === '150' ? 60 : value === '250' ? 60 : 55
      this.htmlToPdfOptions.margin = [8, 10, bottom, 10]
    },
  },
  methods: {
    updateByFiliais() {
      this.gerar()
    },
    gerar() {
      if (this.qrcodes.length === 0) {
        this.errorMessage('É necessário pelo menos um insumo')
        return
      }
      if (this.sizeSelected === null) {
        this.errorMessage('É necessário selecionar o tamanho do QrCode')
        return
      }
      this.isLoading = true
      insumoService
        .buscaQrCode(
          this.qrcodes,
          this.$store.state.filter,
          this.$store.state.filial
        )
        .then((res) => {
          const { data } = res.data

          let filtered = []

          for (const item of data) {
            item.forEach((item) => {
              if (this.qrcodes.includes(String(item.codigo))) {
                filtered.push(item)
              }
            })
          }

          this.items = filtered

          this.$bvModal.show('rel-qrcode')
          this.isLoading = false
        })
        .catch((err) => {
          this.errorMessage(err.response.data.error.message)
          this.isLoading = false
        })
    },
    formatDate(date) {
      if (date) {
        return moment.utc(date).format('DD/MM/YYYY')
      } else {
        return ' '
      }
    },
    async generateReport() {
      await this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const vue = this
      if (this.isSignature) {
        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .output('datauristring')
          .then(function (pdfAsString) {
            vue.signRevenue(pdfAsString)
          })
        return
      }
      this.isLoading = true
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          vue.isLoading = false
        })
        .save()
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
